const rideData = [
  {
    id: "bike",
    rideType: "BIKE",
    standardRide: "Standard",
    luxuryRide: "Business",
    rideImg:
      "https://cdn.pixabay.com/photo/2018/07/31/14/08/sportbike-3575164_1280.png",
    rideSeats: "2",
    standardPrice: "$40",
    luxuryPrice: "$60",
  },
  {
    id: "car",
    rideType: "CAR",
    standardRide: "Standard",
    luxuryRide: "Business",
    rideImg:
      "https://cdn.pixabay.com/photo/2014/04/09/09/42/auto-319930_1280.jpg",
    rideSeats: "4",
    standardPrice: "$120",
    luxuryPrice: "$150",
  },
  {
    id: "bus",
    rideType: "BUS",
    standardRide: "Standard",
    luxuryRide: "Business",
    rideImg:
      "https://cdn.pixabay.com/photo/2019/09/28/07/37/vehicles-4510135_1280.png",
    rideSeats: "4",
    standardPrice: "$20",
    luxuryPrice: "$30",
  },
  {
    id: "train",
    rideType: "TRAIN",
    standardRide: "Standard",
    luxuryRide: "Business",
    rideImg:
      "https://cdn.pixabay.com/photo/2020/10/04/04/41/train-5625222_1280.png",
    rideSeats: "6",
    standardPrice: "$180",
    luxuryPrice: "$200",
  },
];
export default rideData;
